<template>
<div class="row">
      <div class="footer col-12 px-4 py-4 text-left">
            <div class="container">
                <router-link aria-hidden="true" role="presentation" :to="{ name: 'TermsConditions' }">
                    Terms & Conditions
                </router-link>
                <router-link aria-hidden="true" role="presentation" :to="{ name: 'PrivacyPolicy' }">
                    Privacy Policy
                </router-link>
                <router-link  aria-hidden="true" role="presentation" :to="{ name: 'Cookie' }">
                    Cookie Policy
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

const whitelabel = require('../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            contactEmail: whitelabel.contactEmail,
            contactEmailHref: whitelabel.contactEmailHref,
            supportLink: whitelabel.support,
            text: {
                sub: 'We use cookies. You can find out how and why, as well as how to manage them on your device, in our ',
            },
        }
    },
    created() {
    },

}
</script>
